import { render, staticRenderFns } from "./FlashDealsView.vue?vue&type=template&id=8f8e86e0"
import script from "./FlashDealsView.vue?vue&type=script&lang=js"
export * from "./FlashDealsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports